webpackJsonp([36],{

/***/ "bUan":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__("oiih");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__ = __webpack_require__("tQfv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_loader__ = __webpack_require__("39kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__ = __webpack_require__("P71F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_seoMeta__ = __webpack_require__("08z+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_canonical_url__ = __webpack_require__("9XaW");









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_cmsContent__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_loader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_contentLoader__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_seoMeta__["a" /* default */]],
  metaInfo: function metaInfo() {
    var canonicalUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_canonical_url__["a" /* default */])(this.$router, 'news-stories');
    return this.buildSeoMeta({
      title: 'Political News & Prediction Market Insights | PredictIt',
      description: "The latest political news and election analysis, powered by market data. See what PredictIt's prediction markets reveal about the stories that matter.",
      url: canonicalUrl
    });
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapActions */])('browse', ['getStaticPageFull']), {
    installCategoryNav: function installCategoryNav() {
      var categoryNav = this.$el.querySelector('#g-newshubpage .g_newshubpage_cls_category-nav');
      var categoryNavButtons = categoryNav ? categoryNav.querySelectorAll('button') : [];
      var newsItems = this.$el.querySelectorAll('#g-newshubpage .g_newshubpage_cls_js-news-item');

      categoryNavButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          categoryNavButtons.forEach(function (btn) {
            return btn.classList.remove('g_newshubpage_cls_active');
          });
          e.currentTarget.classList.add('g_newshubpage_cls_active');

          var category = e.currentTarget.textContent.trim();
          newsItems.forEach(function (item) {
            var itemCategory = item.getAttribute('data-category') || '';
            var show = category === 'All' || itemCategory === category;
            item.style.display = show ? '' : 'none';
          });
        });
      });
    }
  }),
  created: function created() {
    var _this = this;

    this.loaderAdd(document.body);
    this.getStaticPageFull(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* STATIC_PAGES */].NEWS).then(function (data) {
      _this.isComponentReady = true;
      _this.installDynamicControls({ data: data });
      _this.$nextTick(function () {
        _this.installCategoryNav();
      });
    }).then(function () {
      return _this.loaderRemove(document.body);
    }).catch(function () {
      _this.isComponentReady = true;
      _this.loaderRemove(document.body);
    });
  }
});

/***/ }),

/***/ "cBKw":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("qFk4");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("11c8e274", content, true, {});

/***/ }),

/***/ "jqqL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_news_stories_js__ = __webpack_require__("bUan");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb7cb11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_news_stories_vue__ = __webpack_require__("xdho");
function injectStyle (ssrContext) {
  __webpack_require__("cBKw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_page_news_stories_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb7cb11_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_news_stories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qFk4":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@keyframes pulse{0%{-webkit-transform:scale(1);transform:scale(1);opacity:.6}50%{-webkit-transform:scale(1.0125);transform:scale(1.0125);opacity:.3}to{-webkit-transform:scale(1.025);transform:scale(1.025);opacity:0}}@media screen and (min-width:56.875em){.page-news-stories{padding:18px 0 0}}.page-news-stories__content{background:#fff}", "", {"version":3,"sources":["/home/vsts/work/1/s/src/components/pages/page-news-stories/page-news-stories.scss"],"names":[],"mappings":"AACA,yBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AACD,iBACA,GACI,2BAA4B,AACpB,mBAAoB,AAC5B,UAAa,CAChB,AACD,IACI,gCAAiC,AACzB,wBAAyB,AACjC,UAAa,CAChB,AACD,GACI,+BAAgC,AACxB,uBAAwB,AAChC,SAAW,CACd,CACA,AAQD,uCACA,mBACI,gBAAkB,CACrB,CACA,AACD,4BACE,eAAkB,CACnB","file":"page-news-stories.scss","sourcesContent":["/* stylelint-disable at-rule-no-unknown */\n@-webkit-keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n@keyframes pulse {\n0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.6;\n}\n50% {\n    -webkit-transform: scale(1.0125);\n            transform: scale(1.0125);\n    opacity: 0.3;\n}\n100% {\n    -webkit-transform: scale(1.025);\n            transform: scale(1.025);\n    opacity: 0;\n}\n}\n\n/**\n * Foundation for Sites\n * Version 6.6.3\n * https://get.foundation\n * Licensed under MIT Open Source\n */\n@media screen and (min-width: 56.875em) {\n.page-news-stories {\n    padding: 18px 0 0;\n}\n}\n.page-news-stories__content {\n  background: white;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "xdho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-news-stories"},[(!_vm.isComponentReady)?_c('div',{staticClass:"page-news-stories__content"},[_c('br'),_vm._v(" "),_c('static-page-loader')],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-news-stories__content",domProps:{"innerHTML":_vm._s(_vm.content)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/36.1f155ce49bc99f4811db.js